import { ListItem, styled } from "@mui/material";

export const CustomListItem = styled(ListItem)({
  borderRadius: "10px",
  padding: "0px",
  marginBottom: "25px",
});
